export default function detection(agent) {
    const comp_agent = agent.indexOf('stbcoship9108') != -1;
    if (comp_agent) {
        console.info('[stbcoship9108 detection] detected');
    }
    return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/stbcoship9108/detection.js